import { doc, setDoc } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { functions, db } from "./firebase.service";

type ApiKeys = {
  GA_PROPERTY_ID: string;
  GOOGLE_APPLICATION_CREDENTIALS: string;
  WC_URL: string;
  WC_CONSUMER_KEY: string;
  WC_CONSUMER_SECRET: string;
  MC_API_KEY: string;
  MC_SERVER_PREFIX: string;
};

const base64ToArrayBuffer = (base64: string) => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
};

const encryptWithPublicKey = async (
  publicKeyPem: string,
  plaintext: string
) => {
  // Convert PEM to ArrayBuffer
  const binaryDer = base64ToArrayBuffer(
    publicKeyPem.replace(/-----.*-----/g, "").replace(/\s+/g, "")
  );

  const key = await window.crypto.subtle.importKey(
    "spki",
    binaryDer,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );

  const encoder = new TextEncoder();
  const encoded = encoder.encode(plaintext);

  const encrypted = await window.crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    key,
    encoded
  );

  // Convert ArrayBuffer to base64 for storage
  return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
};

export const setupNewSiteConnection = async (e: React.FormEvent, apiKeys) => {
  e.preventDefault();

  try {
    const getEncryptionKey = httpsCallable(functions, "getEncryptionKey");
    const { data } = await getEncryptionKey();
    const publicKeyPem = (data as any).publicKey as string;

    const encryptedApiKeys: Partial<ApiKeys> = {};
    for (const [key, value] of Object.entries(apiKeys)) {
      if (value) {
        encryptedApiKeys[key as keyof ApiKeys] = await encryptWithPublicKey(
          publicKeyPem,
          value
        );
      }
    }

    const docRef = doc(db, "clients", formData.refCode || formData.clientName);
    await setDoc(docRef, {
      clientName: formData.clientName,
      adminEmail: formData.adminEmail,
      refCode: formData.refCode,
      integrations: formData.integrations,
      apiKeys: encryptedApiKeys,
      createdAt: new Date(),
    });

    console.log("Encrypted form data saved to Firestore!");
  } catch (error) {
    console.error("Error encrypting/saving data:", error);
  }
};
